import type {
  CreateOrderInput,
  EventDetail,
  Order,
  Recommendations,
  SearchResult,
  TicketGroup,
} from "../types/api";

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

if (!baseUrl) {
  console.warn(
    "VITE_API_BASE_URL is not set. API calls will fail. Set it in frontend/.env.local or via the deploy script.",
  );
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${baseUrl}${path}`, {
    headers: { "content-type": "application/json" },
    ...init,
  });
  if (!res.ok) {
    let message = `Request failed: ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body?.error) message = body.error;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return (await res.json()) as T;
}

export const api = {
  recommendations: () => request<Recommendations>("/recommendations"),
  searchEvents: (params: {
    q?: string;
    from?: string;
    to?: string;
    category?: string;
    limit?: number;
    offset?: number;
  }) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== "" && v !== null) qs.set(k, String(v));
    }
    const suffix = qs.toString() ? `?${qs}` : "";
    return request<SearchResult>(`/events${suffix}`);
  },
  getEvent: (id: string) => request<EventDetail>(`/events/${id}`),
  getEventTickets: (id: string) =>
    request<{ ticketGroups: TicketGroup[] }>(`/events/${id}/tickets`),
  createOrder: (input: CreateOrderInput) =>
    request<Order>("/orders", { method: "POST", body: JSON.stringify(input) }),
};
